import { useEffect, useState } from 'react';
import { fetchQuittances, downloadQuittance } from '../services/api';

function formatDate(iso: string): string {
  if (!iso) return '–';
  try { return new Date(iso).toLocaleDateString('fr-FR'); } catch { return iso; }
}

function derivePeriod(r: any): string {
  if (typeof r.period === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(r.period)) return r.period;
  const d = r.payment_date || r.generated_at;
  if (!d) return '–';
  try {
    const dt = new Date(d);
    return `${dt.toLocaleString('fr-FR', { month: 'long' })} ${dt.getFullYear()}`;
  } catch { return '–'; }
}

function formatAmount(r: any): string {
  const usd = r.amount_paid_usd ?? r.amount_usd;
  const cdf = r.amount_paid_cdf ?? r.amount_cdf;
  if (usd != null && cdf != null) return `${usd} USD / ${cdf} CDF`;
  if (usd != null) return `${usd} USD`;
  if (cdf != null) return `${cdf} CDF`;
  return '–';
}

export default function QuittancesPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuittances()
      .then(d => setRows(Array.isArray(d) ? d : []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <div className="error-msg">{error}</div>;
  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div className="card">
      <h3>Quittances</h3>
      <div className="table-wrap" style={{ marginTop: 16 }}>
        <table>
          <thead>
            <tr><th>Référence</th><th>Période</th><th>Date paiement</th><th>Montant</th><th>Solde FPT restant à l’émission</th><th>Statut</th><th>Action</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucune quittance disponible</td></tr>}
            {rows.map((r, i) => (
              <tr key={i}>
                <td>{r.quitus_reference || r.reference || r.id || '–'}</td>
                <td>{derivePeriod(r)}</td>
                <td>{formatDate(r.payment_date)}</td>
                <td>{formatAmount(r)}</td>
                <td>{r.remaining_due_usd==null?"–":`${r.remaining_due_usd} USD`}</td><td><span className="badge green">{r.generated_at ? 'Générée' : 'En attente'}</span></td>
                <td><button className="btn" onClick={() => downloadQuittance(r.id)}>Télécharger</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
